<template>
  <a-config-provider :theme="antTheme">
    <router-view v-slot="{ Component }">
      <keep-alive :max="5">
        <a-style-provider hash-priority="low">
          <component :is="Component" />
        </a-style-provider>
      </keep-alive>
    </router-view>
  </a-config-provider>
</template>

<script>
import 'video.js/dist/video-js.css'
import { theme } from 'ant-design-vue'
import { mapActions } from 'vuex'
import { getColorMode, applyColorMode } from '@/utils/colorMode'

// set up ag-grid license
import { LicenseManager } from 'ag-grid-enterprise'
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-128113}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{The_E.W._Scripps_Company}_is_granted_a_{Multiple_Applications}_Developer_License_for_{8}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{8_June_2027}____[v3]_[01]_MTgxMjQwOTIwMDAwMA==ec8953ca1ffcd79683e92cd61ba4a615'
)

const BASE_TOKEN = {
  fontFamily: 'Nunito,sans-serif',
  colorTextPlaceholder: '#6b7280',
  borderRadius: 2,
  controlHeight: 38
}

export default {
  /* eslint-disable */
  components: {},
  data() {
    return {
      ews_auth: {},
      colorMode: getColorMode(),
      systemDark: window.matchMedia('(prefers-color-scheme: dark)').matches
    }
  },
  computed: {
    isDarkActive() {
      if (this.colorMode === 'dark') return true
      if (this.colorMode === 'light') return false
      return this.systemDark
    },
    antTheme() {
      return {
        algorithm: this.isDarkActive ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: BASE_TOKEN,
        components: {}
      }
    }
  },
  watch: {
    isDarkActive(val) {
      document.documentElement.classList.toggle('dark', val)
    }
  },
  created() {
    applyColorMode(this.colorMode)
    this._mq = window.matchMedia('(prefers-color-scheme: dark)')
    this._mqListener = (e) => { this.systemDark = e.matches }
    this._mq.addEventListener('change', this._mqListener)
    this._cmListener = (e) => { this.colorMode = e.detail }
    window.addEventListener('nd:colormode', this._cmListener)
    window.addEventListener('beforeunload', this.onBeforeUnload)
  },
  beforeUnmount() {
    this._mq.removeEventListener('change', this._mqListener)
    window.removeEventListener('nd:colormode', this._cmListener)
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  methods: {
    ...mapActions(['authenticate']),
    onBeforeUnload(e) {
      const activeUploads = this.$store.getters['activeUploads'] || []
      if (activeUploads.length > 0) {
        e.preventDefault()
      }
    }
  }
}
</script>

<style lang="postcss">
@import './assets/css/app.css';
@import '../node_modules/@videojs/themes/city/index.css';
@import 'ag-grid-community/styles/ag-grid.css';
@import '../node_modules/sweetalert2/dist/sweetalert2.min.css';
@import '../node_modules/floating-vue/dist/style.css';
@import '../node_modules/vue-final-modal/dist/style.css';
@import '../node_modules/vue-simple-calendar/dist/vue-simple-calendar.css';
@import '../node_modules/ant-design-vue/dist/reset.css';
</style>
